import React from 'react';
const C = { bg: '#f9fafb', text: '#111827', muted: '#6b7280', border: '#e5e7eb' };

export default function ArchitectureTab() {
  return (
    <div style={{
      background: C.bg,
      minHeight: '100vh',
      padding: '32px 24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div style={{ maxWidth: 1200, width: '100%' }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: C.text, marginBottom: 6 }}>
            Data Platform Architecture
          </div>
          <div style={{ fontSize: 14, color: C.muted }}>
            One Platform. One Source of Truth.
          </div>
        </div>
        <div style={{
          background: '#000',
          borderRadius: 12,
          overflow: 'hidden',
          boxShadow: '0 4px 32px rgba(0,0,0,0.4)',
          border: `1px solid ${C.border}`,
        }}>
          <img
            src="/architecture.png"
            alt="TCC Data Platform Architecture"
            style={{ width: '100%', display: 'block' }}
          />
        </div>
        <div style={{ marginTop: 20, fontSize: 12, color: C.muted, textAlign: 'center' }}>
          Sources: Bullhorn (ATS/CRM), NetSuite (ERP/Finance), Leadr (People), HRIS/Payroll
          &nbsp;&bull;&nbsp;
          Ingest: Fivetran
          &nbsp;&bull;&nbsp;
          Store: Snowflake (Raw, Staging, Data Marts)
          &nbsp;&bull;&nbsp;
          Model: dbt (Semantic layer, lineage, tests)
          &nbsp;&bull;&nbsp;
          Consume: Amazon QuickSight + AI Query Layer (Claude, ChatGPT)
        </div>
      </div>
    </div>
  );
}
